module.exports = __webpack_public_path__ + "img/syllabus_imge2.832a333d.png";